import { render, staticRenderFns } from "./ProjectRow.vue?vue&type=template&id=e8e82978&scoped=true&"
import script from "./ProjectRow.vue?vue&type=script&lang=js&"
export * from "./ProjectRow.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRow.vue?vue&type=style&index=0&id=e8e82978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e82978",
  null
  
)

export default component.exports